export const skillsKeys = {
  all: ['skills'] as const,
  current: () => [...skillsKeys.all, 'current'] as const,
  details: (slug) => [...skillsKeys.all, slug, 'details'] as const,
  list: () => [...skillsKeys.all, 'list'] as const,
  progress: (slug) => [...skillsKeys.all, slug, 'progress'] as const,
  step: () => [...skillsKeys.all, 'assessment step'] as const,
  topics: (slug: string) => [...skillsKeys.all, slug, 'topics'] as const,
}
